import { amountAsCurrency } from "currency";

import { InfoBanner } from "../../../components";
import useProductFormAPI from "../contexts/ProductFormAPIContext";
import { MerchantPricing, PriceMode } from "../types";

type Props = {
  mode: PriceMode;
};

export default function PriceInfoBanner({ mode }: Props) {
  const { merchantPricing } = useProductFormAPI();

  const text = getText(merchantPricing, mode);
  return <InfoBanner text={text} />;
}

function getText(pricing: MerchantPricing, mode: PriceMode) {
  const key = mode === "one_off" ? "regular_pricing" : "subscriptions_pricing";
  const {
    per_transaction_fee_basis_points,
    per_transaction_fee_cents,
    currency,
  } = pricing[key];

  const amt = amountAsCurrency({
    amount: per_transaction_fee_cents,
    currency,
  });

  const pct = (per_transaction_fee_basis_points / 100).toFixed(1);

  switch (mode) {
    case "one_off":
      return `Los precios únicos con tarjetas Visa y Mastercard generan una comisión de ${pct}% + ${amt} por transacción.`;
    case "recurring":
      return `Los precios recurrentes sólo pueden ser cobrados con tarjetas Visa y Mastercard generan una comisión de ${pct}% + ${amt} por transacción.`;
  }
}
